import { Autocomplete } from '@mui/material';
import { PinnacleTextField } from '../PinnacleTextField';
import { PinnacleAutocompleteProps } from './PinnacleAutocomplete.types';

function PinnacleAutocomplete<T>(props: PinnacleAutocompleteProps<T>) {
  const { label, placeholder, textFieldProps, ...autocompleteProps } = props;

  return (
    <Autocomplete
      {...autocompleteProps}
      renderInput={(params) => (
        <PinnacleTextField
          {...params}
          label={label}
          placeholder={placeholder}
          variant="outlined"
          {...textFieldProps}
          sx={{
            '& .MuiSvgIcon-root': {
              color: '#fff',
            },
            '& .MuiAutocomplete-clearIndicator': {
              color: '#fff',
            },
            '& .MuiAutocomplete-popupIndicator': {
              color: '#fff',
            },
            '& .MuiInputBase-root': {
              color: '#fff',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#A8A8A8 !important',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#A8A8A8 !important',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#A8A8A8 !important',
            },
            '& .Mui-disabled fieldset': {
              borderColor: '#373737 !important',
              color: '#373737 !important',
              WebkitTextFillColor: '#373737',
            },
          }}
        />
      )}
    />
  );
}

export default PinnacleAutocomplete;
